import React, {useState} from 'react';
import {Form, Input, Row, Col, Switch, FormInstance} from 'antd';
import {HttpService} from "../../../../services/http/Http.service";
import {HttpErrorService} from "../../../../services/http/HttpError.service";

interface HeirAddressFormProps {
    form: FormInstance<any>,
    name: number
}

export default function HeirAddressForm({
                                            form,
                                            name
                                        }: HeirAddressFormProps) {
    const [autoFillAddress, setAutoFillAddress] = useState<boolean>(false);
    const requiredIfEditable = !autoFillAddress;

    const handleToggle = async (checked: boolean) => {
        setAutoFillAddress(checked);
        const personCF = form.getFieldValue(["heirs", name, "fiscalCode"]);

        if (checked && personCF) {
            try {
                const data = await HttpService.getInstanceAxios().get(`/person/searchBy?userInput=${personCF}`);
                const addressInfo = data.data?.content?.[0];
                if (addressInfo) {
                    form.setFieldsValue({
                        heirs: {
                            [name]: {
                                province: addressInfo.residenceProvince,
                                city: addressInfo.residenceCity,
                                cap: addressInfo.residencePostalCode,
                                address: addressInfo.residenceAddress,
                                houseNumber: addressInfo.residenceHouseNumber,
                            }
                        }
                    });
                }
            } catch (error) {
                HttpErrorService.handle("Errore durante il recupero dei dati di residenza", error, true);
            }
        } else {
            form.setFieldsValue({
                heirs: {
                    [name]: {
                        province: '',
                        city: '',
                        cap: '',
                        address: '',
                        houseNumber: '',
                    }
                }
            });
        }
    };

    return (
        <>
            <Form.Item label="Vuoi usare l'indirizzo esistente?">
                <Switch checked={autoFillAddress} onChange={handleToggle} />
            </Form.Item>

            <Row gutter={8}>
                <Col span={12}>
                    <Form.Item
                        label="Provincia"
                        name={[name, "province"]}
                        rules={
                            requiredIfEditable
                                ? [
                                    { required: true, message: "Inserisci la provincia!" },
                                    { len: 2, message: "La provincia deve contenere esattamente 2 caratteri!" }
                                ]
                                : [
                                    { len: 2, message: "La provincia deve contenere esattamente 2 caratteri!" }
                                ]
                        }
                    >
                        <Input disabled={autoFillAddress}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Città"
                        name={[name, "city"]}
                        rules={
                            requiredIfEditable
                                ? [{required: true, message: "Inserisci la città!"}]
                                : []
                        }
                    >
                        <Input disabled={autoFillAddress}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={8}>
                <Col span={8}>
                    <Form.Item
                        label="CAP"
                        name={[name, "cap"]}
                        rules={
                            requiredIfEditable
                                ? [{required: true, message: "Inserisci il CAP!"}]
                                : []
                        }
                    >
                        <Input disabled={autoFillAddress}/>
                    </Form.Item>
                </Col>
                <Col span={10}>
                    <Form.Item
                        label="Indirizzo"
                        name={[name, "address"]}
                        rules={
                            requiredIfEditable
                                ? [{required: true, message: "Inserisci l'indirizzo!"}]
                                : []
                        }
                    >
                        <Input disabled={autoFillAddress}/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        label="Civico"
                        name={[name, "houseNumber"]}
                        rules={
                            requiredIfEditable
                                ? [{required: true, message: "Inserisci il numero civico!"}]
                                : []
                        }
                    >
                        <Input disabled={autoFillAddress}/>
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
}